import { Box, Button, Divider, FormGroup, List, ListItem, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PaperHeader from '../../../components/PaperHeader';
import Modal from '../../../components/Modal';
import { FormControlLabelStyled, InfoBox, IOSSwitch } from '../../../style/GlobalStyles';
import { CompanyListItemStyled, CompanyListStyled } from './style';
import { COMPANY_LIST_DETAILS } from '../../../contants';
import InfoIcon from '../../../icons/InfoIcon';
import { LoadingButton } from '@mui/lab';
import { post } from '../../../api';
import SpeakerIcon from '../../../icons/SpeakerIcon';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { CustomChip } from '../../../components/CustomChip';

const SuggestedTasks = ({ tasks = [], updateTask, hasPersonalProducts }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedTask, setSelectedTask] = useState();

    const handleModalOpen = (task) => {
        setSelectedTask(task);
        setIsModalOpen(true);
    };
    const handleModalClose = () => setIsModalOpen(false);

    const theme = useTheme();
    return (
        <>
            <Typography component={'h3'} variant="heading3" color={'text.primary'}>
                Suggested tasks
            </Typography>
            {tasks.map((task) => (
                <Box key={task.taskLabel}>
                    <PaperHeader
                        variant="outlined"
                        icon={<SpeakerIcon sx={{ color: 'icon.brandPrimary' }} />}
                        normalHeading={true}
                        iconSx={{
                            backgroundColor: theme.palette.background.transparent,
                        }}
                        headingText={task.taskLabel}
                        rightSideButton={
                            <Button
                                startIcon={<AddCircleOutlineIcon color="primary" />}
                                onClick={() => handleModalOpen(task)}
                                sx={{
                                    marginTop: {
                                        xs: '0.5rem',
                                        sm: 0,
                                    },
                                    width: {
                                        xs: 'auto',
                                        sm: 'auto',
                                    },
                                    justifyContent: {
                                        xs: 'left',
                                        sm: 'right',
                                    },
                                }}
                            >
                                Add to my business checklist
                            </Button>
                        }
                        // headingStyles={{
                        //     color: theme.palette.secondary.main,
                        // }}
                        sx={{
                            padding: `${theme.typography.generic.medium} ${theme.typography.generic.xLarge}`,
                            margin: `${theme.typography.generic.xLarge} ${theme.typography.generic.none}`,

                            flexDirection: {
                                xs: 'column',
                                sm: 'row',
                            },

                            '& .headingBox': {
                                width: 'unset',
                            },
                        }}
                    />

                    {task.companies?.length > 0 && (
                        <Box display={'flex'} justifyContent={'flex-start'} alignItems={{ xs: 'flex-start', sm: 'center' }} flexDirection={{ xs: 'column', sm: 'row' }}>
                            <Typography color={'text.secondary'} variant="paraText2" whiteSpace={'pre'}>
                                Task added to:{' '}
                            </Typography>
                            <List
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    marginLeft: { xs: '0', sm: '0.5rem' },
                                    marginTop: { xs: '0.5rem', sm: '0' },
                                    padding: 0,
                                    '&>*': {
                                        marginRight: '0.5rem',
                                        '&:last-child': {
                                            marginRight: '0',
                                        },
                                    },
                                }}
                            >
                                {[...task.companies]
                                    ?.sort((companyA, companyB) => companyA.name.localeCompare(companyB.name))
                                    ?.map((cItem) => (
                                        <ListItem
                                            key={cItem.name}
                                            sx={{
                                                padding: `${theme.typography.generic.none}`,
                                                width: 'fit-content',
                                            }}
                                        >
                                            <CustomChip label={cItem.name} color="default" variant="outlined" />
                                        </ListItem>
                                    ))}
                            </List>
                        </Box>
                    )}
                </Box>
            ))}

            {isModalOpen && <SuggestedTaskModal hasPersonalProducts={hasPersonalProducts} isModalOpen={isModalOpen} onModalClose={handleModalClose} task={selectedTask} updateTask={updateTask} />}
        </>
    );
};

const SuggestedTaskModal = ({ isModalOpen = false, onModalClose = () => {}, task, updateTask, hasPersonalProducts }) => {
    const [companyList, setCompanyList] = useState(COMPANY_LIST_DETAILS(!hasPersonalProducts));
    const [loading, setLoading] = useState(false);

    const handleSubmit = () => {
        let companies = companyList.filter((item) => item.checked);
        if (companies.length > 0) {
            setLoading(true);
            post('custom/addTasksFromSolutionTask', { task: task, accountIds: companies.map((item) => item.id) }).then((result) => {
                if (result.isSuccess && result.data) {
                    onModalClose();
                    setLoading(false);
                    let newTask = { ...task };
                    if (!task.companies) {
                        newTask.companies = [];
                    }
                    newTask.companies = [...newTask.companies, ...companies.map((item) => ({ ...item, status: 'Not started' }))];
                    updateTask(newTask);
                }
            });
        }
    };
    const handleChecklist = (currentCheckItem, checkedValue) => {
        const newList = companyList.map((cItem) => {
            if (cItem.id === currentCheckItem.id) {
                // addSuggestTask(cItem);
                const newItem = {
                    ...cItem,
                    checked: checkedValue,
                };
                return newItem;
            } else {
                return cItem;
            }
        });

        setCompanyList(newList);
    };

    useEffect(() => {
        let mapExistingCompanyList = {};
        for (let company of task.companies) {
            mapExistingCompanyList[company.id] = company;
        }

        setCompanyList(
            companyList.map((item) => {
                item.active = !!mapExistingCompanyList[item.id];
                item.status = mapExistingCompanyList[item.id]?.status;
                return item;
            })
        );
    }, []);

    const theme = useTheme();
    return (
        <Modal
            modalOpen={isModalOpen}
            title="Add to Business Checklist"
            subTitle={
                <Box sx={{ lineHeight: '22px' }}>Stay on top of your business by adding this solution to your Business Checklist. Select one or more companies you'd like to relate this task to.</Box>
            }
            hideActions={false}
            handleModalClose={onModalClose}
            handleModalOnSuccess={handleSubmit}
            CancelBtnUI={''}
            SubmitBtnUI={
                <LoadingButton loading={loading} disabled={companyList.filter((item) => item.checked).length === 0} type="button" variant="contained" onClick={handleSubmit || null}>
                    Save
                </LoadingButton>
            }
        >
            <Box component="form" onSubmit={undefined} noValidate>
                {companyList.filter((item) => !item.active).length > 0 ? (
                    <FormGroup sx={{ gap: '0.5rem' }}>
                        {/* <FormLabelStyled color="secondary" htmlFor="select-company">
                                Select Company
                            </FormLabelStyled> */}
                        {companyList
                            .filter((item) => !item.active)
                            .sort((companyA, companyB) => companyA.name.localeCompare(companyB.name))
                            .map((cItem) => (
                                <FormControlLabelStyled
                                    key={cItem.id}
                                    tabIndex={0}
                                    checked={cItem.checked}
                                    onChange={(e) => {
                                        handleChecklist(cItem, e.target.checked);
                                    }}
                                    control={<IOSSwitch name={cItem.name} />}
                                    label={cItem.name}
                                    labelPlacement="start"
                                />
                            ))}
                    </FormGroup>
                ) : (
                    <InfoBox>
                        <InfoIcon />
                        <Typography color={'info.main'} fontSize={'customFontSize.medium'} fontWeight={'fontWeightMedium'} lineHeight={'customFontSize.xLarge'}>
                            All companies are added to this task.
                        </Typography>
                    </InfoBox>
                )}

                {companyList.filter((item) => item.active).length > 0 && (
                    <Box>
                        <Typography
                            component={'h5'}
                            color={'text.tertiary'}
                            variant="heading3"
                            gutterBottom
                            marginTop={theme.typography.generic.xxxxLarge}
                            marginBottom={theme.typography.generic.xLarge}
                        >
                            Task Related To Companies
                        </Typography>
                        <Divider
                            sx={{
                                m: '1rem 0',
                            }}
                        />

                        <CompanyListStyled>
                            {companyList
                                .filter((item) => item.active)
                                .sort((companyA, companyB) => companyA.name.localeCompare(companyB.name))
                                .map((cItem) => (
                                    <CompanyListItemStyled key={cItem.name}>
                                        <Typography
                                            component={'h5'}
                                            color={'text.primary'}
                                            fontSize={'customFontSize.large'}
                                            fontWeight={'fontWeightSemiBold'}
                                            lineHeight={theme.typography.customFontSize.xxxLarge}
                                        >
                                            {cItem.name}
                                        </Typography>
                                        {/* <StatusChip status={cItem.status}></StatusChip> */}

                                        <Box>
                                            {cItem.status === 'Completed' && <CustomChip label="Completed" color="success" variant="outlined" />}
                                            {cItem.status === 'Not started' && <CustomChip label="Not started" color="default" variant="outlined" />}
                                        </Box>
                                    </CompanyListItemStyled>
                                ))}
                        </CompanyListStyled>
                    </Box>
                )}
            </Box>
        </Modal>
    );
};
export default SuggestedTasks;
